export default __webpack_public_path__ + "static/media/ic_exito.4d9cfca0.svg";